import React from 'react';
import DashboardLayout from '../DashboardLayout';

const ServicesLayout: React.FC = () => {
    return (
        <DashboardLayout />
    );
};

export default ServicesLayout;
